import React from "react";

export const ZoomInIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_814_1361)">
            <path
                d="M23.9949 22.583L17.7465 16.3345C21.2404 12.0614 20.6086 5.76493 16.3355 2.27105C12.0624 -1.22282 5.7659 -0.591135 2.27203 3.68199C-1.22185 7.95512 -0.590159 14.2516 3.68297 17.7455C7.36364 20.7549 12.6549 20.7549 16.3355 17.7455L22.584 23.9939L23.9949 22.583ZM10.0252 18.0069C5.61647 18.0069 2.04253 14.4329 2.04253 10.0242C2.04253 5.61554 5.61647 2.04155 10.0252 2.04155C14.4339 2.04155 18.0079 5.61554 18.0079 10.0242C18.003 14.4309 14.4319 18.002 10.0252 18.0069Z"
                fill="currentColor"
            />
            <path
                d="M14.0169 9.02637H6.03418V11.022H14.0169V9.02637Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_814_1361">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ZoomOutIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_814_1365)">
            <path
                d="M24.0001 22.5888L17.7503 16.339C21.2449 12.0649 20.6131 5.76709 16.3391 2.27242C12.065 -1.22225 5.76721 -0.590421 2.27255 3.68369C-1.22212 7.9578 -0.590295 14.2555 3.68376 17.7502C7.36523 20.7603 12.6576 20.7603 16.339 17.7502L22.5889 24L24.0001 22.5888ZM10.0274 18.0117C5.61773 18.0117 2.043 14.437 2.043 10.0273C2.043 5.61761 5.61773 2.04288 10.0274 2.04288C14.4371 2.04288 18.0118 5.61761 18.0118 10.0273C18.0068 14.4349 14.435 18.0067 10.0274 18.0117Z"
                fill="currentColor"
            />
            <path
                d="M11.0254 6.03601H9.0293V9.03015H6.03516V11.0263H9.0293V14.0204H11.0254V11.0263H14.0196V9.03015H11.0254V6.03601Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_814_1365">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const Refresh = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_637_294)">
            <path
                d="M9.0004 1.99996C9.99528 2.00323 10.9796 2.20377 11.8965 2.58998C12.8134 2.97619 13.6445 3.5404 14.3419 4.24996H12.0004C11.8015 4.24996 11.6107 4.32898 11.4701 4.46963C11.3294 4.61029 11.2504 4.80105 11.2504 4.99996C11.2504 5.19888 11.3294 5.38964 11.4701 5.53029C11.6107 5.67095 11.8015 5.74996 12.0004 5.74996H15.1076C15.477 5.74977 15.8311 5.60297 16.0923 5.34182C16.3534 5.08067 16.5002 4.72653 16.5004 4.35721V1.24996C16.5004 1.05105 16.4214 0.860285 16.2807 0.719633C16.1401 0.57898 15.9493 0.499963 15.7504 0.499963V0.499963C15.5515 0.499963 15.3607 0.57898 15.2201 0.719633C15.0794 0.860285 15.0004 1.05105 15.0004 1.24996V2.80846C13.7608 1.69205 12.2348 0.94277 10.5935 0.644525C8.9521 0.346279 7.26012 0.510847 5.70699 1.1198C4.15385 1.72875 2.80091 2.75804 1.79965 4.09241C0.798402 5.42677 0.188377 7.01352 0.037896 8.67496C0.0282085 8.77941 0.0403828 8.88472 0.0736432 8.9842C0.106904 9.08368 0.160521 9.17514 0.231078 9.25275C0.301636 9.33037 0.387587 9.39243 0.483455 9.43499C0.579322 9.47756 0.683005 9.49968 0.787896 9.49996V9.49996C0.971337 9.5023 1.14905 9.43609 1.28624 9.3143C1.42343 9.1925 1.51023 9.02389 1.52965 8.84146C1.69661 6.97453 2.55563 5.23749 3.93796 3.97159C5.32029 2.70569 7.12601 2.00243 9.0004 1.99996Z"
                fill="currentColor"
            />
            <path
                d="M17.2133 9.50018C17.0298 9.49784 16.8521 9.56405 16.7149 9.68585C16.5777 9.80764 16.4909 9.97626 16.4715 10.1587C16.3475 11.5861 15.8167 12.948 14.942 14.0828C14.0673 15.2177 12.8854 16.0778 11.5366 16.5611C10.1878 17.0445 8.72865 17.1308 7.33226 16.8098C5.93588 16.4888 4.66087 15.774 3.6585 14.7502H6C6.19891 14.7502 6.38968 14.6712 6.53033 14.5305C6.67098 14.3899 6.75 14.1991 6.75 14.0002C6.75 13.8013 6.67098 13.6105 6.53033 13.4699C6.38968 13.3292 6.19891 13.2502 6 13.2502H2.89275C2.70982 13.2501 2.52867 13.2861 2.35965 13.356C2.19063 13.426 2.03706 13.5286 1.90771 13.6579C1.77836 13.7872 1.67577 13.9408 1.60582 14.1098C1.53586 14.2789 1.4999 14.46 1.5 14.6429V17.7502C1.5 17.9491 1.57902 18.1399 1.71967 18.2805C1.86032 18.4212 2.05109 18.5002 2.25 18.5002C2.44891 18.5002 2.63968 18.4212 2.78033 18.2805C2.92098 18.1399 3 17.9491 3 17.7502V16.1917C4.23962 17.3081 5.76556 18.0574 7.40693 18.3556C9.04829 18.6539 10.7403 18.4893 12.2934 17.8804C13.8465 17.2714 15.1995 16.2421 16.2007 14.9078C17.202 13.5734 17.812 11.9866 17.9625 10.3252C17.9722 10.2207 17.96 10.1154 17.9268 10.0159C17.8935 9.91647 17.8399 9.82501 17.7693 9.74739C17.6988 9.66978 17.6128 9.60772 17.5169 9.56515C17.4211 9.52259 17.3174 9.50046 17.2125 9.50018H17.2133Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_637_294">
                <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const ChevronDown = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            d="M12.4735 5.47332C12.4116 5.41084 12.3378 5.36124 12.2566 5.32739C12.1753 5.29355 12.0882 5.27612 12.0002 5.27612C11.9122 5.27612 11.8251 5.29355 11.7438 5.32739C11.6626 5.36124 11.5888 5.41084 11.5269 5.47332L8.47354 8.52665C8.41156 8.58913 8.33783 8.63873 8.25659 8.67258C8.17535 8.70642 8.08821 8.72385 8.0002 8.72385C7.9122 8.72385 7.82506 8.70642 7.74382 8.67258C7.66258 8.63873 7.58884 8.58913 7.52687 8.52665L4.47354 5.47332C4.41156 5.41084 4.33783 5.36124 4.25659 5.32739C4.17535 5.29355 4.08821 5.27612 4.0002 5.27612C3.91219 5.27612 3.82506 5.29355 3.74382 5.32739C3.66258 5.36124 3.58884 5.41084 3.52687 5.47332C3.4027 5.59823 3.33301 5.7672 3.33301 5.94332C3.33301 6.11944 3.4027 6.28841 3.52687 6.41332L6.58687 9.47331C6.96187 9.84785 7.4702 10.0582 8.0002 10.0582C8.5302 10.0582 9.03854 9.84785 9.41354 9.47331L12.4735 6.41332C12.5977 6.28841 12.6674 6.11944 12.6674 5.94332C12.6674 5.7672 12.5977 5.59823 12.4735 5.47332Z"
            fill="currentColor"
        />
    </svg>
);

export const ScrollToTop = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_1467_57)">
            <path
                d="M15.0001 18.8333H10.8334V2.85244L14.4168 6.43578C14.5739 6.58757 14.7844 6.67157 15.0029 6.66967C15.2214 6.66777 15.4304 6.58013 15.5849 6.42562C15.7394 6.27112 15.8271 6.06211 15.829 5.84361C15.8309 5.62511 15.7469 5.41461 15.5951 5.25744L11.4734 1.13578C11.28 0.942265 11.0503 0.788759 10.7975 0.684027C10.5447 0.579296 10.2737 0.525391 10.0001 0.525391C9.72646 0.525391 9.4555 0.579296 9.20271 0.684027C8.94991 0.788759 8.72022 0.942265 8.52676 1.13578L4.40176 5.26078C4.2455 5.41748 4.15789 5.62983 4.1582 5.85112C4.15852 6.07241 4.24672 6.28452 4.40342 6.44078C4.56012 6.59703 4.77248 6.68464 4.99377 6.68433C5.21506 6.68402 5.42717 6.59581 5.58342 6.43911L9.16676 2.85578V18.8333H5.00009C4.77908 18.8333 4.56711 18.9211 4.41083 19.0773C4.25455 19.2336 4.16676 19.4456 4.16676 19.6666C4.16676 19.8876 4.25455 20.0996 4.41083 20.2559C4.56711 20.4121 4.77908 20.4999 5.00009 20.4999H15.0001C15.2211 20.4999 15.4331 20.4121 15.5893 20.2559C15.7456 20.0996 15.8334 19.8876 15.8334 19.6666C15.8334 19.4456 15.7456 19.2336 15.5893 19.0773C15.4331 18.9211 15.2211 18.8333 15.0001 18.8333Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_1467_57">
                <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const Charts = {
    Bar: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1548_552)">
                <path d="M34 34V0L0 0V34H34Z" fill="currentColor" />
                <path d="M21 12V6L5 6V12H21Z" fill="white" />
                <path d="M24 20V14L5 14V20H24Z" fill="white" />
                <path d="M28 28V22H5V28H28Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1548_552">
                    <rect
                        width="34"
                        height="34"
                        fill="white"
                        transform="matrix(0 1 -1 0 34 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    StackBar: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1548_544)">
                <path d="M34 34L34 0L0 0L0 34L34 34Z" fill="currentColor" />
                <path d="M21 12L21 6L5 6L5 12L21 12Z" fill="white" />
                <path d="M13 12L13 6L5 6L5 12L13 12Z" fill="#B0537B" />
                <path d="M24 20L24 14L5 14L5 20L24 20Z" fill="white" />
                <path d="M19 20L19 14L5 14L5 20L19 20Z" fill="#B0537B" />
                <path d="M28 28L28 22L5 22L5 28L28 28Z" fill="white" />
                <path d="M16 28L16 22L5 22L5 28L16 28Z" fill="#B0537B" />
            </g>
            <defs>
                <clipPath id="clip0_1548_544">
                    <rect
                        width="34"
                        height="34"
                        fill="white"
                        transform="matrix(0 1 -1 0 34 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    GroupedBar: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1643_684)">
                <path d="M34 34L34 0L0 0L0 34L34 34Z" fill="currentColor" />
                <path d="M24 8L24 4L5 4L5 8L24 8Z" fill="#B0537B" />
                <path d="M28 15L28 11L5 11L5 15L28 15Z" fill="#fff" />
                <path d="M15 24L15 20L5 20L5 24L15 24Z" fill="#B0537B" />            
                <path d="M20 31L20 27L5 27L5 31L20 31Z" fill="#fff" />
            </g>
            <defs>
                <clipPath id="clip0_1643_684">
                    <rect
                        width="34"
                        height="34"
                        fill="white"
                        transform="matrix(0 1 -1 0 34 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    Pie: (props) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            {...props}
        >
            <rect width="34" height="34" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.0059 17.408C28.7953 23.7178 23.7183 28.7948 17.4085 29.0054V17.408L29.0059 17.408ZM28.9637 15.908C28.424 9.91902 23.4886 5.19755 17.4085 4.99463V15.908L28.9637 15.908ZM4.98828 17C4.98828 10.734 9.78606 5.58852 15.9085 5.0368L15.9085 28.9633C9.78606 28.4115 4.98828 23.2661 4.98828 17Z"
                fill="white"
            />
        </svg>
    ),
    Line: (props) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            {...props}
        >
            <rect width="34" height="34" fill="currentColor" />
            <path
                d="M5 25L12.7586 17.0588L17.931 22.3529L30 10"
                stroke="white"
                strokeWidth="3"
            />
        </svg>
    ),
    MultipleLine: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="34" height="34" fill="currentColor" />
            <path
                d="M5 30L12.7586 22.0588L17.931 27.3529L30 15"
                stroke="white"
                strokeWidth="3"
            />
            <path
                d="M5 19L12.7586 11.0588L17.931 16.3529L30 4"
                stroke="#AD4470"
                strokeWidth="3"
            />
        </svg>
    ),
    Heatmap: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width="34" height="34" fill="currentColor" />
            <rect x="2" y="6" width="6" height="4" fill="#FFCFE4" />
            <rect x="10" y="6" width="6" height="4" fill="#E179A5" />
            <rect x="18" y="6" width="6" height="4" fill="#F094C1" />
            <rect x="26" y="6" width="6" height="4" fill="#FFCFE4" />
            <rect x="2" y="12" width="6" height="4" fill="#F094C1" />
            <rect x="10" y="12" width="6" height="4" fill="#AD4470" />
            <rect x="18" y="12" width="6" height="4" fill="#B0537B" />
            <rect x="26" y="12" width="6" height="4" fill="#FFCFE4" />
            <rect x="2" y="18" width="6" height="4" fill="#AD4470" />
            <rect x="10" y="18" width="6" height="4" fill="#E179A5" />
            <rect x="18" y="18" width="6" height="4" fill="#E179A5" />
            <rect x="26" y="18" width="6" height="4" fill="#E179A5" />
            <rect x="2" y="24" width="6" height="4" fill="#E179A5" />
            <rect x="10" y="24" width="6" height="4" fill="#FFCFE4" />
            <rect x="18" y="24" width="6" height="4" fill="#FFCFE4" />
            <rect x="26" y="24" width="6" height="4" fill="#B0537B" />
        </svg>
    ),
    Mosaic: (props) => (
        <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1548_524)">
                <path d="M34 0H0V34H34V0Z" fill="currentColor" />
                <mask
                    id="mask0_1548_524"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="6"
                    y="6"
                    width="13"
                    height="22"
                >
                    <path
                        d="M18.4868 6.00012H6V27.852H18.4868V6.00012Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_1548_524)">
                    <path
                        d="M18.4868 6.00012H6V17.7065H18.4868V6.00012Z"
                        fill="#AD4470"
                    />
                    <path
                        d="M18.4868 19.2673H6V27.852H18.4868V19.2673Z"
                        fill="#E179A5"
                    />
                </g>
                <mask
                    id="mask1_1548_524"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="20"
                    y="6"
                    width="8"
                    height="22"
                >
                    <path
                        d="M27.0705 6H20.8271V27.8519H27.0705V6Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask1_1548_524)">
                    <path
                        d="M27.0705 6H20.8271V10.6825H27.0705V6Z"
                        fill="#AD4470"
                    />
                    <path
                        d="M27.0705 12.2434H20.8271V27.8519H27.0705V12.2434Z"
                        fill="#E179A5"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_1548_524">
                    <rect width="34" height="34" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ),
};

export const Warning = (props) => (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_1548_514)">
            <path
                d="M12.5 0C10.1266 0 7.80655 0.703788 5.83316 2.02236C3.85977 3.34094 2.3217 5.21509 1.41345 7.4078C0.505199 9.60051 0.267559 12.0133 0.730582 14.3411C1.1936 16.6689 2.33649 18.8071 4.01472 20.4853C5.69295 22.1635 7.83115 23.3064 10.1589 23.7694C12.4867 24.2324 14.8995 23.9948 17.0922 23.0866C19.2849 22.1783 21.1591 20.6402 22.4776 18.6668C23.7962 16.6935 24.5 14.3734 24.5 12C24.4966 8.81846 23.2312 5.76821 20.9815 3.51852C18.7318 1.26883 15.6815 0.00344108 12.5 0V0ZM12.5 22C10.5222 22 8.58879 21.4135 6.9443 20.3147C5.29981 19.2159 4.01809 17.6541 3.26121 15.8268C2.50433 13.9996 2.3063 11.9889 2.69215 10.0491C3.078 8.10929 4.03041 6.32746 5.42894 4.92893C6.82746 3.53041 8.60929 2.578 10.5491 2.19215C12.4889 1.8063 14.4996 2.00433 16.3268 2.76121C18.1541 3.51808 19.7159 4.79981 20.8147 6.4443C21.9135 8.08879 22.5 10.0222 22.5 12C22.4971 14.6513 21.4426 17.1931 19.5679 19.0679C17.6931 20.9426 15.1513 21.9971 12.5 22V22Z"
                fill="#A479E9"
            />
            <path
                d="M12.4998 10.0005H11.4998C11.2345 10.0005 10.9802 10.1058 10.7926 10.2934C10.6051 10.4809 10.4998 10.7353 10.4998 11.0005C10.4998 11.2657 10.6051 11.5201 10.7926 11.7076C10.9802 11.8951 11.2345 12.0005 11.4998 12.0005H12.4998V18.0005C12.4998 18.2657 12.6051 18.5201 12.7926 18.7076C12.9802 18.8951 13.2345 19.0005 13.4998 19.0005C13.765 19.0005 14.0193 18.8951 14.2069 18.7076C14.3944 18.5201 14.4997 18.2657 14.4997 18.0005V12.0005C14.4997 11.4701 14.289 10.9613 13.914 10.5863C13.5389 10.2112 13.0302 10.0005 12.4998 10.0005Z"
                fill="#A479E9"
            />
            <path
                d="M12.5 7.99951C13.3284 7.99951 14 7.32794 14 6.49951C14 5.67108 13.3284 4.99951 12.5 4.99951C11.6716 4.99951 11 5.67108 11 6.49951C11 7.32794 11.6716 7.99951 12.5 7.99951Z"
                fill="#A479E9"
            />
        </g>
        <defs>
            <clipPath id="clip0_1548_514">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);
